import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { useCallback } from 'react';

const useTrackException = () => {
    const appInsCtx = useAppInsightsContext();

    return useCallback(
        (exception: Error, properties?: Record<string, unknown>) => {
            const appInsights = appInsCtx.getAppInsights();
            appInsights.trackException({
                exception,
                severityLevel: SeverityLevel.Error,
                properties
            });
        },
        [appInsCtx]
    );
};

export default useTrackException;
